// 法律声明 / 隐私保护等内容页
import { getPortalLegalPage } from '@/api/portal'
import { toLegalApiKey } from '@/components/portal/common/utils/portalPageLoader'

const inflightRequests = new Map()

export default {
  namespaced: true,
  state: {
    pageMap: {},
    loadingMap: {},
    errorMap: {},
    locale: ''
  },
  getters: {
    getPage: (state) => (pagePath) => {
      const key = toLegalApiKey(pagePath)
      if (!key || !Object.prototype.hasOwnProperty.call(state.pageMap, key)) return undefined
      return state.pageMap[key]
    },
    isLoading: (state) => (pagePath) => Boolean(state.loadingMap[toLegalApiKey(pagePath)]),
    getError: (state) => (pagePath) => state.errorMap[toLegalApiKey(pagePath)] || ''
  },
  mutations: {
    SET_PAGE(state, { key, data, locale }) {
      state.pageMap = { ...state.pageMap, [key]: data }
      state.locale = locale || ''
    },
    SET_LOADING(state, { key, loading }) {
      state.loadingMap = { ...state.loadingMap, [key]: loading }
    },
    SET_ERROR(state, { key, error }) {
      state.errorMap = { ...state.errorMap, [key]: error || '' }
    },
    RESET(state) {
      state.pageMap = {}
      state.loadingMap = {}
      state.errorMap = {}
      state.locale = ''
    }
  },
  actions: {
    resetForLocaleChange({ commit }) {
      commit('RESET')
    },
    async fetchLegalPage({ commit, state, rootState }, payload = {}) {
      const { pagePath, force = false } = payload
      const locale = rootState.locale.current
      const key = toLegalApiKey(pagePath)
      if (!locale || !key) return null

      if (!force && state.locale === locale && Object.prototype.hasOwnProperty.call(state.pageMap, key)) {
        return state.pageMap[key]
      }

      const requestKey = `${locale}:${key}:${force ? '1' : '0'}`
      if (inflightRequests.has(requestKey)) {
        return inflightRequests.get(requestKey)
      }

      const task = (async () => {
        commit('SET_LOADING', { key, loading: true })
        commit('SET_ERROR', { key, error: '' })
        try {
          const data = await getPortalLegalPage(key, locale)
          commit('SET_PAGE', { key, data: data || null, locale })
          return data
        } catch (error) {
          commit('SET_ERROR', { key, error: error?.message || '加载失败' })
          commit('SET_PAGE', { key, data: null, locale })
          return null
        } finally {
          commit('SET_LOADING', { key, loading: false })
        }
      })()

      inflightRequests.set(requestKey, task)
      try {
        return await task
      } finally {
        inflightRequests.delete(requestKey)
      }
    }
  }
}
